import React from 'react'
import { motion } from 'framer-motion'

const PartnerCarousel: React.FC = () => {
  const partners = [
    { name: 'Visa', logo: '/logos/card_visa.svg' },
    { name: 'Mastercard', logo: '/logos/card_mastercard.svg' },
    { name: 'Google Pay', logo: '/logos/card_google-pay.svg' },
    { name: 'PayPal', logo: '/logos/card_paypal.svg' },
    { name: 'American Express', logo: '/logos/card_american_express.svg' },
    { name: 'Skrill', logo: '/logos/card_skrill_sofort.svg' },
    { name: 'Apple Pay', logo: '/logos/card_apple-pay.svg' },
    { name: 'Stripe', logo: '/logos/card_stripe.svg' },
  
  ];

  return (
    <section className="py-16 bg-brand-gray-dark overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Trusted by <span className="gradient-text">Global Partners</span>
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            We work with the world's leading payment providers to offer you the best solutions
          </p>
        </div>

        {/* Animated Carousel */}
        <motion.div
          className="flex space-x-12 w-max"
          animate={{ x: ['0%', '-50%'] }}
          transition={{
            repeat: Infinity,
            repeatType: 'loop',
            duration: 20,
            ease: 'linear',
          }}
        >
          {[...partners, ...partners].map((partner, i) => (
            <div key={`${partner.name}-${i}`} className="w-36 h-24 flex items-center justify-center">
              <img src={partner.logo} alt={partner.name} className="h-16 object-contain" />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerCarousel;
